import { Box } from "@mui/material";
import React, {
  Dispatch,
  FC,
  JSX,
  SetStateAction,
  useEffect,
  useState,
} from "react";
import MainTableContainer from "./MainTableContainer";

// import PtaxDetailsCard from "../PTAXDetailsCard";
import "jspdf-autotable";
import jsPDF from "jspdf";
import { CSVLink } from "react-csv";
import { getValueByColumn } from "ka-table/Utils/DataUtils";
import {
  DataType,
  ActionType,
  EditingMode,
  ITableProps,
  PagingPosition,
  SortingMode,
  Table,
  useTable,
} from "ka-table";
import {
  ActionButtonTypes,
  KATableActionBttnsTypes,
  KATableHeaderTypes,
} from "./SweetTable.interface";
import "./index.css";
import { table } from "console";
import moment from "moment";
type GeneralKATableProps = {
  attachCardWrapper?: boolean;
  tableTitle?: string;
  setSearchText?: Dispatch<SetStateAction<string>>;
  tableColumns: Array<KATableHeaderTypes>;
  tableData: Array<any>;
  searchText?: string;
  rowKeyField?: string;
  cellActionBtns?: Array<KATableActionBttnsTypes>;
  actionBtns?: Array<ActionButtonTypes>;
  downloadPDF?: boolean;
  downloadExcel?: boolean;
  filterApplicable?: boolean;
  isSSR?: boolean;
  pageIndex?: number;
  setPageIndex?: Dispatch<SetStateAction<number>>;
  APILoading?: boolean;
  pageSize?: number;
  setPageSize?: Dispatch<SetStateAction<number>>;
  searchAction?: (params: any) => any;
  pageCount?: number;
  actionBtnsReq?: boolean;
  PDFFRomServer?: any;
  ExcelDownloadFromServer?: any;
  customeComponent?: any;
  orientaion?: "landscape" | "portrait";
  rowColors?: Array<{ index: number; color: string }>;
  searchTitle?: string;
  isPaging?: boolean;
  searchDropdownLabel?: any;
  searchDropdownKey?: any;
  searchDropdownList?: any[];
  FormHandler?: any;
  setSearchKeyVal?: any;
  isTypeSearch?: boolean;
  CustomePageSizes?: number[];
  isPageSizeGiven?: boolean;
  searchClearAction?: any;
  filtersAllow?: boolean;
  ColumnSettings?: boolean;
  isRightClickable?:any
};
const LandTable: FC<GeneralKATableProps> = ({
  attachCardWrapper = true,
  tableTitle = "Table Title",
  searchText,
  setSearchText,
  tableColumns,
  tableData,
  actionBtns,
  cellActionBtns,
  downloadPDF = false,
  downloadExcel = false,
  filterApplicable = false,
  setPageIndex,
  pageIndex,
  isSSR = false,
  APILoading = false,
  pageSize,
  setPageSize,
  searchAction,
  pageCount,
  actionBtnsReq,
  customeComponent,
  orientaion,
  PDFFRomServer,
  ExcelDownloadFromServer,
  rowColors,
  searchTitle,
  isPaging,
  FormHandler,
  searchDropdownKey,
  searchDropdownLabel,
  searchDropdownList,
  setSearchKeyVal,
  isTypeSearch = false,
  CustomePageSizes,
  isPageSizeGiven,
  searchClearAction,
  filtersAllow = true,
  ColumnSettings = false,
  isRightClickable
}): JSX.Element => {
  const table = useTable({
    onDispatch: async (action, newState) => {
      if (action.type === ActionType.UpdatePageIndex) {
        setPageIndex?.(action.pageIndex);
      }
      if (action.type === ActionType.UpdatePageSize) {
        setPageSize?.(action.pageSize);
        setPageIndex?.(0);
      }
    },
  });


  //   ********************* Download PDF Action ************************* //
  const exportClickForPDF = (orientation?: any) => {
    const doc: any = new jsPDF(orientation);
    const head = [table.props.columns.map((c) => c.title)];
    //
    //

    const body = table.props.data!.map((d) => {
      let keys: any =
        !!table?.props?.data && table?.props?.data.length > 0
          ? Object.keys(table?.props?.data[0])
          : [];
      let tempTablekeys: any =
        !!table?.props?.columns && table?.props?.columns?.length > 0
          ? table?.props?.columns?.map((col: any) => ({
              key: col?.key,
              type: col?.dataType,
            }))
          : [];
      //
      //
      //

      // return  tempTablekeys.map((self:any)=>d[self]);
      return tempTablekeys?.map((self: any) =>
        self?.type === "date"
          ? moment(d[self?.key]).format("DD-MM-YYYY")
          : d[self?.key]
      );
      // return keys.filter((self:any)=>tempTablekeys.includes(self)).map((c: any) => d[c])
    });
    doc.autoTable({
      margin: 1,
      headStyles: { fillColor: "#F1F5F7", textColor: "#747D86" },
      alternateRowStyles: { fillColor: "#F9FBFC" },
      head,
      body,
    });
    const pdfName = tableTitle.split(" ").join("-");

    doc.save(`${pdfName}.pdf`);
  };

  let timeOut: NodeJS.Timeout;
  useEffect(() => {
    if (!isTypeSearch) {
      timeOut = setTimeout(() => {
        searchAction?.(searchText);
      }, 500);
    }
    return () => {
      !!timeOut && clearTimeout(timeOut);
    };
  }, [searchText]);

  return (
    <Box width="100%" height="100%">
      {attachCardWrapper ? (
        // <PtaxDetailsCard
        //   title={tableTitle}
        //   leftAnchor={
        //     media.isBelowMediumScreen
        //       ? "5%"
        //       : media.isAboveMediumScreen
        //         ? "7%"
        //         : media.isBelowLargeScreen
        //           ? "12%"
        //           : "17%"
        //   }
        // >
        <MainTableContainer
          tableTitle={tableTitle}
          searchText={searchText}
          setSearchText={setSearchText}
          tableColumns={tableColumns}
          tableData={tableData}
          cellActionBtns={cellActionBtns}
          actionBtns={actionBtns}
          table={table}
          downLoadPDF={downloadPDF}
          downloadEXCEL={downloadExcel}
          pdfAction={isSSR ? PDFFRomServer : exportClickForPDF}
          filterApplicable={filterApplicable}
          pageIndex={pageIndex}
          APILoading={APILoading}
          pageSize={pageSize}
          searchAction={searchAction}
          isSSR={isSSR}
          pageCount={pageCount}
          actionBtnsReq={actionBtnsReq}
          customeComponent={customeComponent}
          orientaion={orientaion}
          ExcelDownloadFromServer={ExcelDownloadFromServer}
          rowColors={rowColors}
          searchTitle={searchTitle}
          isPaging={isPaging}
          FormHandler={FormHandler}
          searchDropdownKey={searchDropdownKey}
          searchDropdownLabel={searchDropdownLabel}
          searchDropdownList={searchDropdownList}
          setSearchKeyVal={setSearchKeyVal}
          isTypeSearch={isTypeSearch}
          CustomePageSizes={CustomePageSizes}
          isPageSizeGiven={isPageSizeGiven}
          searchClearAction={searchClearAction}
          filtersAllow={filtersAllow}
          ColumnSettings={ColumnSettings}
        />
      ) : (
        // </PtaxDetailsCard>
        <MainTableContainer
          tableTitle={tableTitle}
          searchText={searchText}
          setSearchText={setSearchText}
          tableColumns={tableColumns}
          tableData={tableData}
          cellActionBtns={cellActionBtns}
          actionBtns={actionBtns}
          table={table}
          downLoadPDF={downloadPDF}
          downloadEXCEL={downloadExcel}
          filterApplicable={filterApplicable}
          pageIndex={pageIndex}
          APILoading={APILoading}
          searchAction={searchAction}
          isSSR={isSSR}
          pageCount={pageCount}
          actionBtnsReq={actionBtnsReq}
          customeComponent={customeComponent}
          orientaion={orientaion}
          pdfAction={isSSR ? PDFFRomServer : exportClickForPDF}
          ExcelDownloadFromServer={ExcelDownloadFromServer}
          rowColors={rowColors}
          searchTitle={searchTitle}
          isPaging={isPaging}
          FormHandler={FormHandler}
          searchDropdownKey={searchDropdownKey}
          searchDropdownLabel={searchDropdownLabel}
          searchDropdownList={searchDropdownList}
          setSearchKeyVal={setSearchKeyVal}
          isTypeSearch={isTypeSearch}
          CustomePageSizes={CustomePageSizes}
          isPageSizeGiven={isPageSizeGiven}
          searchClearAction={searchClearAction}
          filtersAllow={filtersAllow}
          ColumnSettings={ColumnSettings}

        />
      )}
    </Box>
  );
};

export default LandTable;
